export enum RetailMatchSelectionMethod {
  BRANDS = 1,
  CATEGORIES = 2,
}
